export const GET_UDDER_DETAILS_REQUEST = "GET_UDDER_DETAILS_REQUEST";
export const GET_UDDER_DETAILS_REQUEST_SUCCESS =
  "GET_UDDER_DETAILS_REQUEST_SUCCESS";
export const GET_UDDER_DETAILS_REQUEST_ERROR =
  "GET_UDDER_DETAILS_REQUEST_ERROR";
export const RESET_UDDER_DETAILS = "RESET_UDDER_DETAILS";
